import React from 'react'

import img1 from './img/opat1.jpg'
import img2 from './img/opat2.jpg'



function opisCra() {
  return (
    <div className='opis-container'>
      <div className='opis-header'>
        
        <h1>Opatkowianka - Grębałowianka</h1> 
       
       
      </div>

      <div className='opis-info'>
          <p>
          Zaległa 5 kolejka I ligi oldboyów Kraków <br></br>
Opatkowianka -Grębałowianka Kraków 2:2(1:1)<br></br>
Bramki dla Gręby: 0:1 Strojek R as.Oleś <br></br>
1:2  Oleś as. Strojek R <br></br>
Skład Grębałowianki: Kokosza - Rutka, Dominik, Korcala, Wierzbinski, Strojek G, Karaś, Oleś , Lampart, Mucharski, Strojek R, Grzywa, Kawula, Natkaniec, Gadzina. <br></br>
Trener Bernard Łach <br></br>
Gościnnie Kot Antoni <br></br>
Zaległy mecz 5 kolejki mecz z Opatkowianką rozgrywany był w ośrodku treningowym w Skotnikach. Gospodarze wzmocnieni kilkoma młodymi zawodnikami goście w miarę możliwości zebrani w liczbie 15 osób. Spotkanie stało na wysokim poziomie akcja za akcję. Gręba miała swoje okazje sytuacje Karasia, Mucharskiego i Lamparta nie znalazły drogi do bramki. Po jednej z akcji gości błąd popełnił bramkarz gospodarzy i instynktownym zachowaniem zachował się Robert Strojek który plasowanym strzałem umieścił piłkę przy słupku. Opatkowianka ruszyła z większym natężeniem a efekt bramka wyrównująca do szatni.
Po zmianie stron mecz niczym się nie zmienił intensywność z dwóch stron i sporo akcji bramkowych w tym stuprocentowa Gadziny który zbyt długo zwlekał z oddaniem strzału w sytuacji sam na sam z bramkarzem.Ładna akcja środkiem pola Strojek R podaje prostopadłą w pole karne do Olesia a ten plasowanym strzałem po długim rogu wyprowadza gości na prowadzenie 2:1. Grębałowianka kontrolowała grę starając się utrzymać korzystny wynik do końca meczu. Niestety rywal przeprowadzil szybką kontrę. Wynik końcowy 2:2 pewnie sprawiedliwy choć przy odrobinie szczęścia można było się pokusić o zwycięstwo. Szanujemy ten punkt na trudnym terenie. 
Dziękujemy za przybycie i zaangażowanie w meczu dla dobra wyniku. 
Teraz przerwa. Czas odpoczynku i ładowaniu baterii. 
Z ligą wracamy na rundę rewanżową dopiero pod koniec sierpnia. <br></br>
Pozdrawiam Piotr Grzywa 😉 👌 ⚽
          
          </p>

        <img src={img1} alt='gre-dab'></img>
        <img src={img2} alt='gre-dab'></img>
     
        
       
      </div>
        
        </div>
  )
}

export default opisCra